import React from 'react';

import { ResumeGeneratorLayout } from './ResumeGeneratorLayout';

const ResumeGeneratorContainer: React.FC = () => {

	return (
		<React.Fragment>
			<ResumeGeneratorLayout />
		</React.Fragment>
	);
};

export default ResumeGeneratorContainer;